import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const MiniCardStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    width: 100%;
    max-width: 351px;
    background-color: ${(props) => props.theme.colors.backgrounds.white};

    @media screen and (max-width: 360px) {
        width: 95%;
    }

    @media screen and (min-width: 768px) {
        flex-direction: row;
        max-width: 922px;
    }

    .bg-image,
    .content {
        width: 100%;

        @media screen and (min-width: 768px) {
            min-width: 50%;
        }
    }

    .bg-image {
        background: url(${(props) => props.bgImage}) no-repeat;
        background-size: contain;
        background-position: center;
        height: 174px;
    }

    .content {
        display: flex;
        align-items: center;
        /* height: 150px; */
        width: auto;
        padding: 0 11px 0 46px;
        /* background-color: ${(props) =>
            props.theme.colors.backgrounds.white}; */

        @media screen and (min-width: 768px) {
            /* height: 174px; */
        }
        @media screen and (max-width: 767px) {
            padding: 20px;
            flex-direction: column;
            justify-content: center;
            text-align: center;
        }

        .stat {
            font: 300 3rem ${(props) => props.theme.fonts[0]}, sans-serif;
            line-height: 3.5rem;
            letter-spacing: -1.05px;
            margin-right: 35px;
            @media screen and (max-width: 767px) {
                margin: 5px 0;
            }
        }

        .title {
            font: 1.5rem ${(props) => props.theme.fonts[0]}, sans-serif;
            line-height: 2.125rem;
            letter-spacing: -0.7px;
        }
    }
`;

export default function MiniCard({ bgImage, stat, title }) {
    return (
        <MiniCardStyled bgImage={bgImage?.url} title={bgImage?.title}>
            {bgImage ? <div className="bg-image"></div> : null}
            <div className="content">
                <p className="stat">{stat}</p>
                <p className="title">{title}</p>
            </div>
        </MiniCardStyled>
    );
}

MiniCard.propTypes = {
    bgImage: PropTypes.string.isRequired,
    stat: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
